module.exports = __webpack_public_path__ + "static/media/discount-price.64dc8807.svg";